import BASE_RULE from '../baseRule';
import {SearchTypeAdvancedRaw} from './constants';
import {AdvancedRawRule} from './types';

export const advancedRawRuleDefaults: Readonly<AdvancedRawRule> = {
	...BASE_RULE,
	elementType: SearchTypeAdvancedRaw,
	elementSubType1: 4,
	elementValue1: '',
};

export default advancedRawRuleDefaults;
